import type { UiLocale } from './coachCatalog.js';

/**
 * Strings of the live skill chips (W6, D7 / D9). Spanish first (speak's UI is
 * es-first, rioplatense, voseo); the English pair is ready for when the UI has
 * a locale. Specific, never generic praise: each chip names WHAT was earned.
 */
export interface SkillChipsCopy {
  /** "✓ Voz pasiva · 2/3" — a counted rep of a grammar skill. */
  grammar: (label: string, reps: number, total: number) => string;
  /** "✓ «wait for» · antes te costaba" — a radar focus used right (D9). */
  nailed: (headline: string, quoted: boolean) => string;
  /** "✓ Voz pasiva · completada" — the skill completed now. */
  completed: (label: string) => string;
  /** Context line under a nailed chip: the radar focus it beat. */
  focusContext: (focusLabel: string) => string;
  /** Screen-reader sentences (the chip text is compressed). */
  grammarAria: (label: string, reps: number, total: number) => string;
  nailedAria: (headline: string) => string;
  completedAria: (label: string) => string;
}

export const SKILL_CHIPS_COPY: Record<UiLocale, SkillChipsCopy> = {
  es: {
    grammar: (label, reps, total) => `${label} · ${reps}/${total}`,
    nailed: (headline, quoted) => `${quoted ? `«${headline}»` : headline} · antes te costaba`,
    completed: (label) => `${label} · completada`,
    focusContext: (focusLabel) => `Tu radar: ${focusLabel}`,
    grammarAria: (label, reps, total) => `Usaste bien: ${label}. Llevás ${reps} de ${total}.`,
    nailedAria: (headline) => `Lo clavaste: ${headline}. Antes te costaba.`,
    completedAria: (label) => `Completaste la habilidad: ${label}.`,
  },
  en: {
    grammar: (label, reps, total) => `${label} · ${reps}/${total}`,
    nailed: (headline, quoted) => `${quoted ? `"${headline}"` : headline} · you used to miss this`,
    completed: (label) => `${label} · completed`,
    focusContext: (focusLabel) => `Your radar: ${focusLabel}`,
    grammarAria: (label, reps, total) => `You used it right: ${label}. ${reps} of ${total}.`,
    nailedAria: (headline) => `You nailed it: ${headline}. You used to get this wrong.`,
    completedAria: (label) => `You completed the skill: ${label}.`,
  },
};
